/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { Box, styled } from '@mui/material';
import Typography from '../../../../components/Typography';
import { ItemLabel } from '../../../../components/styled';

export const PriceContainer = styled('div')({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  gap: '24px',
});

export const PriceItemContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
});

export const PriceRRP = styled(ItemLabel)({
  fontWeight: 700,
});

export const PriceDiscounted = styled(Typography)(({ theme }) => ({
  color: theme.colors.secondary700,
  fontWeight: 700,
}));

export const PriceCancelled = styled(Typography)(({ theme }) => ({
  color: theme.colors.secondary700,
  fontWeight: 700,
  textDecoration: 'line-through',
}));
